// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3717fe0c]{display:none}[data-v-3717fe0c] p{margin:0}[data-v-3717fe0c] .sf-table__data:nth-child(2){--table-column-flex:2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
